import { toChartData } from './chart-data';
import { pickOverviewGoal } from './goals';
import { buildStatValues } from './month-stats';
import { toTransactions } from './transactions';

export const EMPTY_DASHBOARD_DATA = {
	incomes: [],
	expenses: [],
	goals: [],
	incomeCategories: [],
	expenseCategories: [],
	overview: [],
};

export const buildDashboardView = (data, currency, intl) => {
	const overviewGoal = pickOverviewGoal(data.goals);

	return {
		hasCurrencyData: data.overview.some(item => item.currency === currency),
		overviewGoal,
		goalsCount: data.goals.length,
		statValues: buildStatValues({
			overview: data.overview,
			currency,
			goal: overviewGoal,
			intl,
			now: new Date(),
		}),
		chartData: toChartData(data.overview, currency, intl),
		transactions: toTransactions(data),
		expenses: data.expenses,
		expenseCategories: data.expenseCategories,
	};
};
